import CloseIcon from "@/components/icons/CloseIcon";
import IconCheckCircleChecked from "@/components/icons/IconCheckCircleChecked";

interface ValidationStatusIconProps {
  /** `undefined` means the API has no verdict for this field — render nothing. */
  isValid: boolean | undefined;
}

export const ValidationStatusIcon = ({
  isValid,
}: ValidationStatusIconProps) => {
  if (isValid === undefined) {
    return null;
  }

  return isValid ? (
    <span aria-label="Gyldig" className="text-success flex-shrink-0" role="img">
      <IconCheckCircleChecked height={20} width={20} />
    </span>
  ) : (
    <span
      aria-label="Mangler eller ugyldig"
      className="text-danger flex-shrink-0"
      role="img"
    >
      <CloseIcon height={20} width={20} />
    </span>
  );
};
